<template>
  <div>
    <carousel class="mb-4"></carousel>
    <div class="row mb-2">
      <div class="col-md-6">
        <div class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
          <div class="col p-4 d-flex flex-column position-static">
            <h3 class="mb-0">大乳山旅游度假区</h3>
            <p class="card-text mb-auto">大乳山风景区位于山东威海乳山市大乳山周围，是一处集观光旅游、休闲度假、文化娱乐、养生康体的综合性大型旅游胜地。</p>
          </div>
          <div class="col-auto d-none d-lg-block">
            <svg class="bd-placeholder-img" width="200" height="200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: Thumbnail"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm position-relative">
          <div class="col p-4 d-flex flex-column position-static">
            <h3 class="mb-0">银滩旅游度假区</h3>
            <p class="mb-auto">乳山银滩人文自然景观丰富。银滩沙子洁白如银，因而获得“银滩”之名，被誉为“天下第一滩”、“东方夏威夷”。</p>
          </div>
          <div class="col-auto d-none d-lg-block">
            <svg class="bd-placeholder-img" width="200" height="200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: Thumbnail"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"/><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Carousel from '@/components/home/Carousel'
export default {
  data() {
    return {

    }
  },
  components: {
    Carousel
  }
}
</script>